import React from 'react';
import { Alert } from '@mui/material';
import { useSelector } from 'react-redux';

import { DonationProviderData } from 'entities/donation/api';
import { selectUser } from 'entities/user/selectors';

interface Props {
  donationProviderData: DonationProviderData | null;
}

export const DonationToChaptersWarningMessage = ({ donationProviderData }: Props) => {
  const user = useSelector(selectUser);
  const routedNonprofits = (donationProviderData?.donateViaNonprofits ?? []).filter(
    (donateViaNonprofit) => donateViaNonprofit.routed
  );

  if (!user?.isAdmin || !routedNonprofits?.length) {
    return null;
  }

  return routedNonprofits?.map((donateViaNonprofit) => (
    <Alert
      key={donateViaNonprofit.payeeId}
      variant="outlined"
      severity="info"
      sx={{ marginTop: 1 }}
    >
      The donation will be routed to the parent organization{' '}
      <strong>{donateViaNonprofit.name}</strong> ({donateViaNonprofit.payeeId}) and a designation
      note will be added recommending that the funds from this donation should be routed to{' '}
      <strong>{donateViaNonprofit.childname}</strong>
    </Alert>
  ));
};
